import React from "react";
import { Redirect, Route, Switch } from "react-router";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Error404 from "./Pages/404";
import Login from "./Auth/Login";
import Register from "./Auth/Register";
import ForgotPasswordPage from "./Auth/ForgotPassword";
import Users from "./Pages/users";
import CreateUser from "./Pages/users/CreateUser";
import UpdateUser from "./Pages/users/UpdateUser";
import axios from "../services/auth/jwt/config";
import Tests from "./Pages/testspage";
import Questions from "./Pages/Questions";
import CreateTest from "./Pages/testspage/CreateTest";
import EditTest from "./Pages/testspage/EditTest";
import Dashboard from "./Pages/Dashboard";
import Comments from "./Pages/Comments";
import News from "./Pages/News";
import ReportCards from "./Pages/ReportCard";
import ReportCardResults from "./Pages/ReportCard/Results";
import ReportCardObjections from "./Pages/ReportCard/Objections";
import Events from "./Pages/eventsPage";
import EditEvent from "./Pages/eventsPage/EditEvent";
import CreateEvent from "./Pages/eventsPage/CreateEvent";
import EventSections from "./Pages/eventsPage/sections";
import SectionTickets from "./Pages/eventsPage/sectionTickets";
import Media from "./Pages/Media";
import MainAccessList from "./Pages/AccessList";
import Gallery from "routes/Pages/Gallery";
import CreateGellery from "./Pages/Gallery/CreateGallery";
import AccessListManagement from "./Pages/AccessListMamagement";
import Banners from "./Pages/Banners";
import DesktopSlides from "./Pages/DesktopSlides";
import CreateBlog from "./Pages/News/createBlog";
import CreateBanner from "./Pages/Banners/CreateBanner";
import FormBuilder from "./Pages/FormBuilder";
import Forms from "./Pages/Forms";
import FormInputs from "./Pages/FormInputs";
import FormTickets from "./Pages/FormTickets";
import FormTicketAnswers from "./Pages/FormTickets/Answers";
import FormInputFillDetails from "./Pages/FormInputs/FormInputFillDetails";
import EventTokenList from "./Pages/EventTokenList";
import QuizTicketList from "./Pages/testspage/QuizTicketList";
import KeyManagent from "./Pages/KeyManagement";
import Answer from "./Pages/testspage/Answer";
import PointShop from "./Pages/PointShop";
import CreatePrize from "./Pages/PointShop/cratePrize";
import ScoreManagement from "./Pages/ScoreManagement";
import Notifications from "./Pages/Notifications";
import Tickets from "./Pages/Tickets";
import TicketDetails from "./Pages/Tickets/TicketDetails";
import JoftPoochCoinManagement from "./Pages/JoftPoochCoinManagement";
import Hubble from "./Pages/Hubble";
import HubbleDetails from "./Pages/Hubble/HubbleDetails";
import Judges from "./Pages/Hubble/Judges";
import HubbleReferee from "./Pages/Hubble/HubbleReferee";
import HubbleRefereeDetails from "./Pages/Hubble/HubbleRefereeDetails";
import QuizCheats from "./Pages/QuizCheats";
import ManageWords from "./Pages/ManageWords";
import Participants from "./Pages/ManageWords/Participants";
import PrizeDetails from "./Pages/PointShop/PrizeDetails";
import Point from "./Pages/Point";
import PointBank from "./Pages/Point/PointBank";
import Purchases from "./Pages/purchases";
import PurchaseDetails from "./Pages/purchases/PurchaseDetails";
import Vow from "./Pages/Vow";
import AdminLog from "./Pages/AdminLog";
import AdminLogDetails from "./Pages/AdminLog/AdminLogDetails";
import WordGameEvents from "./Pages/WordGameEvents";
import CreateWGEvent from "./Pages/WordGameEvents/CreateWGEvent";
import EditWGEvent from "./Pages/WordGameEvents/EditWGEvent";
import MarthonDanieEvents from "./Pages/marathonDanie";
import CreateMarathonEvent from "./Pages/marathonDanie/CreateMarathonEvent";
import MarathonEventQuestions from "./Pages/marathonDanie/MarathonEventQuestions";
import MarathonTicketList from "./Pages/marathonDanie/MarathonTicketList";
import MarathonAnswerPage from "./Pages/marathonDanie/MarathonAnswerPage";
import MarathonscoreManagement from "./Pages/marathonDanie/MarathonScoreManagement";

const RestrictedRoute = ({ component: Component, ...rest }) => {
  const { token } = useSelector(({ auth }) => auth);

  return (
    <Route
      {...rest}
      render={(props) =>
        token ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/signin",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const Routes = () => {
  const { token } = useSelector(({ auth }) => auth);

  const location = useLocation();
  if (!token && location.pathname !== "/signin") {
    return <Redirect to="/signin" />;
  } else if (localStorage.getItem("Token") && location.pathname === "/signin") {
    return <Redirect to="/" />;
  } else if (
    sessionStorage.getItem("Token") &&
    location.pathname === "/signin"
  ) {
    return <Redirect to="/" />;
  }

  if (localStorage.getItem("Token") || sessionStorage.getItem("Token")) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("Token")
        ? localStorage.getItem("Token")
        : sessionStorage.getItem("Token")
      }`;
  } else {
    axios.defaults.headers.common["Authorization"] = "";
  }

  return (
    <React.Fragment>
      <Switch>
        <Route path="/signin" component={Login} />
        <Route path="/signup" component={Register} />
        <Route path="/forgot-password" component={ForgotPasswordPage} />
        <RestrictedRoute path="/users" component={Users} />
        <RestrictedRoute path="/tests" component={Tests} />
        <RestrictedRoute path="/createTest" component={CreateTest} />
        <RestrictedRoute path="/editTest/:id" component={EditTest} />
        <RestrictedRoute path="/answer/:id/:quiz" component={Answer} />
        <RestrictedRoute
          path="/quizTicketList/:id"
          component={QuizTicketList}
        />
        <RestrictedRoute path="/questions/:id" component={Questions} />
        <Route path="/addUser" component={CreateUser} />
        <RestrictedRoute path="/editUser/:id" component={UpdateUser} />
        <RestrictedRoute path="/comments/:id" component={Comments} />
        <RestrictedRoute path="/reportcards/:id/results" component={ReportCardResults} />
        <RestrictedRoute path="/reportcards/:id/objections" component={ReportCardObjections} />
        <RestrictedRoute exact path="/reportcards" component={ReportCards} />
        <RestrictedRoute path="/news" component={News} />
        <RestrictedRoute path="/addNews" component={CreateBlog} />
        <RestrictedRoute path="/events" component={Events} />
        <RestrictedRoute path="/createEvent" component={CreateEvent} />
        <RestrictedRoute path="/eventSections/:id" component={EventSections} />
        <RestrictedRoute path="/editEvent/:id" component={EditEvent} />
        <RestrictedRoute
          path="/sectionTickets/:id"
          component={SectionTickets}
        />
        <RestrictedRoute path="/media" component={Media} />
        <RestrictedRoute path="/accessList" component={MainAccessList} />
        <RestrictedRoute
          path="/accessListManagment"
          component={AccessListManagement}
        />
        <RestrictedRoute path="/gallery" component={Gallery} />
        <RestrictedRoute path="/createGallery" component={CreateGellery} />
        <RestrictedRoute path="/banners" component={Banners} />
        <RestrictedRoute path="/desktop-slides" component={DesktopSlides} />
        <RestrictedRoute path="/createBanner" component={CreateBanner} />
        <RestrictedRoute path="/eventTokenList" component={EventTokenList} />
        <RestrictedRoute path="/formBuilder/:id" component={FormBuilder} />
        <RestrictedRoute path="/formBuilder" component={FormBuilder} />
        <RestrictedRoute path="/forms" component={Forms} />
        <RestrictedRoute path="/formtickets/:id/:ticketId/answers" component={FormTicketAnswers} />
        <RestrictedRoute path="/formtickets/:id" component={FormTickets} />
        <RestrictedRoute path="/forminputs/:id" component={FormInputs} />
        <RestrictedRoute
          path="/formFillDetails/:id"
          component={FormInputFillDetails}
        />
        <RestrictedRoute path="/keyManagement" component={KeyManagent} />
        <RestrictedRoute path="/scoreManagement" component={ScoreManagement} />
        <RestrictedRoute path="/pointShop/edit/:id" component={PrizeDetails} />
        <RestrictedRoute path="/purchases" component={Purchases} />
        <RestrictedRoute path="/purchaseDetails/:id" component={PurchaseDetails} />
        <RestrictedRoute path="/pointShop" component={PointShop} />
        <RestrictedRoute path="/point" component={Point} />
        <RestrictedRoute path="/pointBank" component={PointBank} />
        <RestrictedRoute path="/addPrize" component={CreatePrize} />
        <RestrictedRoute path="/notifications" component={Notifications} />
        <RestrictedRoute path="/tickets" component={Tickets} />
        <RestrictedRoute path="/ticketDetails/:id" component={TicketDetails} />
        <RestrictedRoute path="/coinManagement" component={JoftPoochCoinManagement} />
        <RestrictedRoute path="/hubble" component={Hubble} />
        <RestrictedRoute path="/hubbleDetails/:id" component={HubbleDetails} />
        <RestrictedRoute path="/judges" component={Judges} />
        <RestrictedRoute path="/hubbleReferee" component={HubbleReferee} />
        <RestrictedRoute path="/hubbleRefereeDetails/:id" component={HubbleRefereeDetails} />
        <RestrictedRoute path="/quizCheats" component={QuizCheats} />
        <RestrictedRoute path="/wordGame/manageWords" component={ManageWords} />
        <RestrictedRoute path="/wordGame/participants" component={Participants} />
        <RestrictedRoute path="/wordGame/events" component={WordGameEvents} />
        <RestrictedRoute path="/wordGame/createEvent" component={CreateWGEvent} />
        <RestrictedRoute path="/wordGame/editEvent/:id" component={EditWGEvent} />
        <RestrictedRoute path="/vow" component={Vow} />
        <RestrictedRoute path="/adminLog" component={AdminLog} />
        <RestrictedRoute path="/adminLogDetails/:id" component={AdminLogDetails} />
        <RestrictedRoute path="/marathonDanie" component={MarthonDanieEvents} />
        <RestrictedRoute path="/createMarathonEvent" component={CreateMarathonEvent} />
        <RestrictedRoute path="/editMarathonEvent/:id" component={CreateMarathonEvent} />
        <RestrictedRoute path="/marathonEventQuestions/:id/:eventName" component={MarathonEventQuestions} />
        <RestrictedRoute path="/marathonEventParticipants/:id/:eventName" component={MarathonTicketList} />
        <RestrictedRoute path="/marathonAnswer/:id/:quiz" component={MarathonAnswerPage} />
        <RestrictedRoute path="/marathonScoreManagement" component={MarathonscoreManagement} />
        <RestrictedRoute path="/" component={Dashboard} />
        <Route component={Error404} />
      </Switch>
    </React.Fragment>
  );
};

export default Routes;
